
<template>
    <div class="center">
        <vs-row>
            <vs-col sm="12" lg="3" class="ml-auto">
                <vs-input v-model="search" placeholder="Buscar">
                    <template #icon>
                        <i class="fas fa-search"></i>
                    </template>
                </vs-input>
            </vs-col>
        </vs-row>
        <vs-table striped>
            <template #thead>
                <tr>
                    <editar v-model="activeEditar" :selectInfo="selectInfo" :ciclosEscolares="ciclosEscolares" :instituciones="instituciones" @refreshTable="getRefresh"></editar>
                    <eliminar v-model="activeEliminar" :selectInfo="selectInfo" @refreshTable="getRefresh"></eliminar>
                </tr>
                <vs-tr>
                    <vs-th sort @click="users = $vs.sortData($event ,users, 'nombre')">
                        Nombre
                    </vs-th>
                    <vs-th sort @click="users = $vs.sortData($event ,users, 'fecha_vigencia')">
                        Fecha de vigencia
                    </vs-th>
                    <vs-th>
                        Acciones
                    </vs-th>
                </vs-tr>
            </template>
            <template #tbody>
            <vs-tr
                :key="i"
                v-for="(tr, i) in $vs.getSearch(users, search)"
                :data="tr"
            >
                <vs-td>
                    {{ tr.nombre }}
                </vs-td>
                <vs-td>
                    <i class="far fa-calendar-alt"></i> {{ tr.fecha_vigencia }}
                </vs-td>
                <vs-td>
                    <vs-row>
                        <vs-col sm="6" lg="6"> 
                            <vs-button
                                icon
                                success
                                size="mini"
                                class="m-auto"
                                @click="activeEditar = ! activeEditar, selectInfo = tr"
                            >
                                <i class="far fa-edit" style="font-size: 10px"></i>
                            </vs-button>
                        </vs-col>
                        <vs-col sm="6" lg="6">
                            <vs-button
                                icon
                                danger
                                size="mini"
                                class="m-auto"
                                @click="activeEliminar = ! activeEliminar, selectInfo = tr"
                            >
                                <i class="far fa-trash-alt" style="font-size: 10px"></i>
                            </vs-button>
                        </vs-col>
                    </vs-row>
                </vs-td>
            </vs-tr>
            </template>
            <template #notFound>
                Sin información
            </template>

        </vs-table>
    </div>
</template>
<script>
import editar from './modales/editar.vue'
import eliminar from './modales/eliminar.vue'
export default {
    props: [
        'users',
        'ciclosEscolares',
        'instituciones'
    ],
    data:() => ({
        search: '',
        activeEditar: false,
        activeEliminar: false,
        selectInfo: []
    }),
    components: {
        editar,
        eliminar
    },
    methods:{
        getRefresh(){
            this.$emit('refreshTable')
        }
    }
}
</script>

        